import { render, staticRenderFns } from "./MailingListsModifyDialog.vue?vue&type=template&id=b49a15da&"
import script from "./MailingListsModifyDialog.vue?vue&type=script&lang=ts&"
export * from "./MailingListsModifyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./MailingListsModifyDialog.vue?vue&type=style&index=0&id=b49a15da&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports